import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

const initialState = {
  bonusUsageData: [],
  freeGamesData: [],
  spinsConfig: [],
  mobLoader: false,
  loader: false,
};

export const bonusUsageSlice = createSlice({
  name: "bonusUsage",
  initialState,
  reducers: {
    setBonusUsageData: (state, action) => {
      state.bonusUsageData = action.payload;
    },
    setFreeGamesData: (state, action) => {
      state.freeGamesData = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setSpinsConfig: (state, action) => {
      state.spinsConfig = action.payload;
    },
  },
});
export const bonusUsage = (uid, pageNum) => (dispatch) => {
  const token = getFromLocalStorage("gk");
  dispatch(setLoader(true));
  let url = endpoints?.bonusUsage;
  const payload = {
    accessToken: token,
    clientType: "mobile",
    userId: uid?.toString(),
    itemsPerPage: 10,
    pageNumber: pageNum,
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setBonusUsageData(res?.data?.result?.data));
      dispatch(setLoader(false));
    } else {
    }
  });
};
export const freeGamesUsage = (uid, pageNum) => (dispatch) => {
  const token = getFromLocalStorage("gk");
  dispatch(setLoader(true));
  let url = endpoints?.bonusUsage;
  const payload = {
    accessToken: token,
    clientType: "mobile",
    userId: uid?.toString(),
    itemsPerPage: 10,
    pageNumber: pageNum,
    bonusSubType: "FREE_SPIN",
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setFreeGamesData(res?.data?.result?.data));
      dispatch(setLoader(false));
    } else {
    }
  });
};

export const getFreeSpinsData = (bonusId, userId) => (dispatch) => {
  console.log("bonusId: ", bonusId);
  const token = getFromLocalStorage("gk");
  dispatch(setLoader(true));
  let url = endpoints?.freespins;
  const payload = {
    accessToken: token,
    bonusId: bonusId.toString(),
    userId: userId?.toString(),
    clientType: "mobile",
    itemsPerPage: 10,
    pageNumber: 0
  };
  return postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setSpinsConfig(res?.data?.result));
      dispatch(setLoader(false));
      return res;
    } else {
      dispatch(setLoader(false));
    }
  })
};

export const {
  setBonusUsageData,
  setFreeGamesData,
  setLoader,
  setTotalRecords,
  setSpinsConfig,
} = bonusUsageSlice.actions;

export default bonusUsageSlice.reducer;
